import React from "react";

const RESUME_URL =
  "https://docs.google.com/document/d/16uCdXxQvh0nHSWvTPWInytmxGiwbuZH4SAyfnhnBSvI/edit?usp=sharing";

function DownloadButton() {
  const handleDownload = () => {
    window.open(RESUME_URL, "_blank", "noopener,noreferrer");
  };

  return <button onClick={handleDownload}>Download Resume</button>;
}

export default DownloadButton;
